import { Link } from "react-router-dom";
import type { Experience } from "../content/experience";
import { CaseStudyVisual } from "./CaseStudyVisual";

export function CaseStudyCard({ item }: { item: Experience }) {
  return (
    <article className="case-study" id={item.id}>
      <div className="case-study-top">
        <CaseStudyVisual type={item.visual} />
        <div className="case-study-heading">
          <p className="case-meta">
            {item.industry} · {item.role}
          </p>
          <h2>{item.title}</h2>
          <p className="case-situation">{item.situation}</p>
        </div>
      </div>

      <dl className="case-highlights">
        {item.highlights.map((h) => (
          <div key={h.label} className="case-highlight">
            <dt>{h.label}</dt>
            <dd>{h.value}</dd>
          </div>
        ))}
      </dl>

      <ul className="case-outcomes">
        {item.outcomes.map((outcome) => (
          <li key={outcome}>{outcome}</li>
        ))}
      </ul>

      <details className="case-details">
        <summary>How we worked</summary>
        <ul>
          {item.approach.map((step) => (
            <li key={step}>{step}</li>
          ))}
        </ul>
      </details>

      <div className="tag-row">
        {item.tags.map((tag) => (
          <span key={tag} className="tag">
            {tag}
          </span>
        ))}
      </div>
    </article>
  );
}

export function ExperienceCta() {
  return (
    <aside className="cta-band">
      <h2>Talk about a project</h2>
      <p className="muted">
        Bring what is broken today. We will tell you if we are the right fit.
      </p>
      <Link className="btn" to="/contact">
        Start a conversation
      </Link>
    </aside>
  );
}
